import React from 'react';
import PropTypes from 'prop-types';
import * as Style from './style';

const FunnelChart = ({
    number,
    numberTwo,
    numberThree,
    numberFour,
    numberFive,
    text,
    textTwo,
    textThree,
    textFour,
    textFive,
    percentage,
}) => (
	<Style.Container>
		<Style.ConversionData>
			<div>
				<div role="cell">
					<em>{number}</em>
					<em>{text}</em>
				</div>
			</div>
		</Style.ConversionData>
		<Style.ConversionData>
			<div>
				<div role="cell">
					<em>{numberTwo}</em>
					<em>{textTwo}</em>
				</div>
			</div>
		</Style.ConversionData>
		<Style.ConversionData>
			<div>
				<div role="cell">
					<em>{numberThree}</em>
					<em>{textThree}</em>
				</div>
			</div>
		</Style.ConversionData>
		<Style.ConversionData>
			<div>
				<div role="cell">
					<em>{numberFour}</em>
					<em>{textFour}</em>
				</div>
			</div>
		</Style.ConversionData>
		<Style.ConversionData>
			<div>
				<div role="cell">
					<em>{numberFive}</em>
					<em>{textFive}</em>
				</div>
			</div>
		</Style.ConversionData>
		<Style.MyConvesionTitle>Conversão</Style.MyConvesionTitle>
		<Style.MyConversionPercentage>{percentage}</Style.MyConversionPercentage>
		<Style.MyConversion>Minha <br />conversão</Style.MyConversion>
	</Style.Container>
);

FunnelChart.defaultProps = {
	text: 'Leads gerados',
	textTwo: 'Leads em negociação',
	textThree: 'Visitas agendadas',
	textFour: 'Visitas realizadas',
	textFive: 'Vendas realizadas',
};

FunnelChart.propTypes = {
	text: PropTypes.string,
	textTwo: PropTypes.string,
	textThree: PropTypes.string,
	textFour: PropTypes.string,
	textFive: PropTypes.string,
};

export default FunnelChart;
